import { LoaderFunctionArgs, redirect } from 'react-router-dom';
import { RouterContext } from '../../router';
// import { getActiveUser } from 'utils';

export const index = true;

export const loader = async (
  params: LoaderFunctionArgs,
  context: RouterContext,
) => {
  const url = new URL(params.request.url);
  if (url.pathname === '/') {
    return redirect('/home' + url.search);
  }
  return null;
};

export const Page = null;
